import { Grid, CircularProgress, Typography } from '@material-ui/core';
import axios from 'axios';
import React, { FC, useEffect, useState } from 'react';
import styled from 'styled-components';
import YouTube from 'components/Common/YouTube';
import SalesArea from 'components/SalesArea/Container/SalesArea';

const StyledText = styled.div`
  line-height: 1.2rem;
  font-size: 0.9rem;
  margin-bottom: 1.5rem;
`;

type wpEmbedYouTubeData = {
  acf: {
    /**
     * 埋め込み用YouTubeのURL
     */
    youtubeUrl: string;
    /**
     * 動画概要
     */
    youtubeDescription: string;
  };
};

const Hello: FC = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [isError, setIsError] = useState(false);
  const [youtubeContent, setYoutubeContent] = useState<wpEmbedYouTubeData>();

  // 埋め込み用YouTubeデータをWPから取得
  useEffect(() => {
    const getContents = async () => {
      setIsError(false);
      setIsLoading(true);
      try {
        const response = await axios.get(
          `https://dxjmemwogeqvm.cloudfront.net/wp-json/wp/v2/hido_embed_youtube/958?_fields=acf`,
        );
        setYoutubeContent(response.data ?? '');
      } catch (err) {
        setIsError(true);
      }
      setIsLoading(false);
    };
    void getContents();
  }, []);

  return (
    <>
      <Grid container spacing={3}>
        {isError && (
          <Grid container spacing={3} alignItems="center" justify="center">
            {/* <StyledTitle> HTB online劇場</StyledTitle> */}
            <Grid item xs={12}>
              <Typography
                gutterBottom
                variant="body2"
                component="p"
                align="center"
              >
                <br />
                <br />
                エラーが発生しました
              </Typography>
            </Grid>
          </Grid>
        )}
        {isLoading ? (
          <>
            <Grid container spacing={3} alignItems="center" justify="center">
              <Grid item xs={12}>
                <Typography
                  gutterBottom
                  align="center"
                  variant="h6"
                  component="p"
                >
                  <br />
                  <br />
                  通信中
                </Typography>
                <Typography gutterBottom align="center">
                  <CircularProgress color="primary" />
                </Typography>
              </Grid>
            </Grid>
          </>
        ) : (
          <Grid item xs={12}>
            <YouTube YouTubeURL={youtubeContent?.acf.youtubeUrl ?? ''} />
            <StyledText
              dangerouslySetInnerHTML={{
                __html: youtubeContent?.acf.youtubeDescription ?? '',
              }}
            />
          </Grid>
        )}
        <Grid item xs={12}>
          <SalesArea />
        </Grid>
      </Grid>
    </>
  );
};

export default Hello;
